import React from "react";
import { useLocation } from "react-router-dom";
import { Breadcrumbs } from "@mui/material";
import { BaseBox, BaseTypography, BaseLink } from "../exports";
import { HEADER_HEIGHT, BREADCRUMB_BAR_HEIGHT } from "../layoutConstants";
import ROUTE_LABELS from "../../Constant/Breadcrumbs/RouteLabels";

// Maps route paths to breadcrumb labels; unmapped segments fall back to a
// humanized version of the path segment (dashes -> spaces, title case).


function humanizeSegment(segment) {
  return segment.replaceAll("-", " ").replace(/\b\w/g, (char) => char.toUpperCase());
}

function buildBreadcrumbs(pathname) {
  const segments = pathname.split("/").filter(Boolean);
  if (segments.length === 0 || pathname === "/home") {
    return [{ label: "Home", path: "/home" }];
  }
  const crumbs = [{ label: "Home", path: "/home" }];
  let cumulativePath = "";
  segments.forEach((segment) => {
    cumulativePath += `/${segment}`;
    crumbs.push({
      label: ROUTE_LABELS[cumulativePath] || humanizeSegment(segment),
      path: cumulativePath,
    });
  });
  return crumbs;
}

// A dedicated fixed section below the header, holding only the breadcrumb
// trail (AWS console style), present on every authenticated page.
export default function BaseBreadcrumbBar() {
  const location = useLocation();
  const breadcrumbs = buildBreadcrumbs(location.pathname);

  return (
    <BaseBox
      sx={{
        position: "fixed",
        top: HEADER_HEIGHT,
        left: 0,
        width: "100%",
        minHeight: BREADCRUMB_BAR_HEIGHT,
        display: "flex",
        alignItems: "center",
        bgcolor: "#f9f9f9",
        borderBottom: "1px solid rgba(0,0,0,0.08)",
        zIndex: 990,
        px: 2,
      }}
    >
      <Breadcrumbs
        separator="›"
        aria-label="breadcrumb"
        sx={{
          fontSize: "0.8rem",
          "& .MuiBreadcrumbs-separator": { color: "text.disabled" },
        }}
      >
        {breadcrumbs.map((crumb, index) =>
          index === breadcrumbs.length - 1 ? (
            <BaseTypography key={crumb.path} sx={{ fontSize: "0.8rem", fontWeight: 600 }}>
              {crumb.label}
            </BaseTypography>
          ) : (
            <BaseLink key={crumb.path} to={crumb.path} sx={{ fontSize: "0.8rem", fontWeight: 400 }}>
              {crumb.label}
            </BaseLink>
          )
        )}
      </Breadcrumbs>
    </BaseBox>
  );
}
